export const VEHICLE_COMPONENT_MAPPING_ADD = 'serviceData.VEHICLE_COMPONENT_MAPPING_ADD';
export const VEHICLE_COMPONENT_MAPPING_ADD_COMMIT = 'serviceData.VEHICLE_COMPONENT_MAPPING_ADD_COMMIT';
export const VEHICLE_COMPONENT_MAPPING_REMOVE = 'serviceData.VEHICLE_COMPONENT_MAPPING_REMOVE';
export const VEHICLE_COMPONENT_MAPPING_REMOVE_COMMIT = 'serviceData.VEHICLE_COMPONENT_MAPPING_REMOVE_COMMIT';
export const VEHICLE_COMPONENT_MAPPING_HIT_POINTS_SET = 'serviceData.VEHICLE_COMPONENT_MAPPING_HIT_POINTS_SET';
export const VEHICLE_COMPONENT_MAPPING_HIT_POINTS_SET_COMMIT = 'serviceData.VEHICLE_COMPONENT_MAPPING_HIT_POINTS_SET_COMMIT';
